module.exports = __webpack_public_path__ + "static/img/banner.0022eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gene_factory/banner.png
// module id = 9T0w
// module chunks = 1